export default __webpack_public_path__ + "static/media/lengkungbawah.9c39205a.png";